import { Flow } from '../../interfaces/Flow'
import { GET_FLOW, GET_FLOW_EXITO } from '../types/flowActionsTypes'

export type FlowAction = FlowActionSuccess | FlowActionAsync

// Acción síncrona: guarda en Redux los flows traídos o el error
export interface FlowActionSuccess {
  type: typeof GET_FLOW_EXITO
  flows: Flow[] | undefined
  error: string | undefined
}

export const getFlowsAction = (
  flows?: Flow[],
  error?: string
): FlowActionSuccess => ({
  type: GET_FLOW_EXITO,
  flows,
  error
})

// Acción para disparar la saga
export interface FlowActionAsync {
  type: typeof GET_FLOW
}

export const getFlowsActionAsync = (): FlowActionAsync => ({
  type: GET_FLOW
})
